import React, { useContext, useEffect, useState } from 'react';
import {
    Row,
    Col, Nav, NavItem, Container
} from 'reactstrap';
import { Link } from 'react-router-dom';
import img1 from '../assets/images/accounting-icon.svg';
import img3 from '../assets/images/hr&payroll-icon.svg';
import img4 from '../assets/images/integration-icon.svg';
import img5 from '../assets/images/subscription-icon.svg';
import img6 from '../assets/images/setting-icon.svg';
import app from "assets/images/connect.svg";
import img7 from 'assets/images/users-icon.svg';
import { useUserContext, useClient, useOrganisationContext } from "../hooks";
import { Trans } from "react-i18next";
import { all, any, PermissionWrapper } from 'Helpers'
import { accountingPerms, applicationPerms, hrPerms, integrationPerms, settingPerms, userAndSubsPerms } from './PermissionsList';
import EmployeeContext from 'contexts/EmployeeContext';

const SelectionComponents = () => {
    const { isAdmin, query, permissions, isUser, isInTrialPeriod, } = useUserContext();
    const { employee } = useContext(EmployeeContext);

    const client = useClient();
    
    const { selectedOrganisation, organisations } = useOrganisationContext();

    const [subscribedFeatures, setSubscribedFeatures] = useState({
        isAccounting: isInTrialPeriod,
        isWPConnect: isInTrialPeriod,
        isPayroll: isInTrialPeriod,
        isActive: isInTrialPeriod,
    })
    
    useEffect(() => {
        if (!isInTrialPeriod && selectedOrganisation?.subscribed_features) { 
            let subFeatures = selectedOrganisation?.subscribed_features
            let accounting = subFeatures?.hesaabmodule?.includes('accounting')
            let wpconnect = subFeatures?.hesaabmodule?.includes('wpconnect')
            let payroll = subFeatures?.hesaabmodule?.includes('payroll')
            let active = accounting || wpconnect || payroll

            setSubscribedFeatures({
                isAccounting: accounting,
                isWPConnect: wpconnect,
                isPayroll: payroll,
                isActive: active,
            })
        }

    }, [selectedOrganisation, ])

    const getTargetUrl = (module) => { 
        if (module === 'accounting') {
            return '/accounts_receivable/'
        } else if (module === 'hrpayroll') {
            if (permissions.includes('hr_payroll_dashboard')) {
                return '/payroll/dashboard'
            } else {
                return '/payroll/pay_runs'
            }
        }

        return '#'
    }

    const {
        isAccounting,
        isWPConnect,
        isPayroll,
        isActive,
    } = subscribedFeatures

    return (
        <div className ='selectionComponents text-center'>
            <Row>
                <Col xs="12" md="12" sm="12">
                    <Container>
                        <div className='selection-conat' style={{ paddingTop: '150px' }}>
                            <h4 style={{ fontSize: '35px', fontWeight: '700', }}><Trans>What services do you need?</Trans></h4>
                            <p><Trans>Hesaab is your all in one Financial Management System, Integrated with Xero.</Trans></p>
                            <hr />
                            <Nav className='d-flex justify-content-center align-items-center vh-100'>
                                {isAccounting &&
                                    <PermissionWrapper permissions={permissions} access={accountingPerms} func={any}>
                                        <NavItem>
                                            <Link to={ getTargetUrl('accounting') }>
                                                <div>
                                                    <img src={img1} alt="accounting" width="30" />
                                                </div>
                                                <Trans>Accounting</Trans></Link>
                                        </NavItem>
                                    </PermissionWrapper>
                                }
                                {/* <NavItem>
                    <Link to="#">
                    <div className="mr-2 text-nowrap">
                            <img src={img2} alt="user"  width="19" />
                            </div>
                            Electronic invoices</Link>
                </NavItem> */}
                                {isPayroll &&
                                    <PermissionWrapper permissions={permissions} access={hrPerms} func={any}>
                                        <NavItem>
                                            <Link to={getTargetUrl('hrpayroll')}>
                                                <div >
                                                    <img src={img3} alt="hr" width="30" />
                                                 </div>
                                                <Trans>HR & Payroll</Trans></Link>
                                        </NavItem>
                                    </PermissionWrapper>
                                }
                                {isAccounting &&
                                    <PermissionWrapper permissions={permissions} access={integrationPerms} func={all}>
                                        <NavItem>
                                            <Link to="/e-invoicing" className='text-nowrap'>
                                                <div>
                                                    <img src={img4} alt="integration" width="30" />
                                                </div>
                                                <Trans>Add-ons</Trans></Link>
                                        </NavItem>
                                    </PermissionWrapper>
                                }

                                {/* <>
                                {isUser && <PermissionWrapper permissions={permissions} access={userAndSubsPerms} func={all}>
                                    <NavItem>
                                        <Link to="/allusers" className='text-nowrap'>
                                            <div>
                                                <img src={img7} alt="user" width="30" />
                                            </div>
                                            <Trans>Users</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>}
                                </> */}
                                
                                {isUser && <PermissionWrapper permissions={permissions} access={userAndSubsPerms} func={all}>
                                    <NavItem>
                                        <Link to="/subscription" className='text-nowrap'>
                                            <div>
                                                <img src={img5} alt="subscription" width="33" />
                                            </div>
                                            <Trans>Subscription</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>}
                                {employee && 
                                        <NavItem>
                                            <Link to="/employee_payroll" className='text-nowrap'>
                                                <div>
                                                    <img src={img7} alt="e-portal" width="33" />
                                                </div>
                                                <Trans>Employee Portal</Trans></Link>
                                        </NavItem>
                                }
                                {(isUser || employee) && <PermissionWrapper permissions={permissions}>
                                    <NavItem>
                                        <Link to="/tasks/task-management" className='text-nowrap'>
                                            <div>
                                                <img src={app} alt="task-manager" width="33" />
                                            </div>
                                            <Trans>Task Management</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>} 
                                {isUser && <PermissionWrapper permissions={permissions} access={applicationPerms} func={all}>
                                    <NavItem>
                                        <Link to="/applications" className='text-nowrap'>
                                            <div>
                                                <img src={app} alt="applications" width="33" />
                                            </div>
                                            <Trans>Applications</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>
                                }

                                {(isUser || employee) && <PermissionWrapper permissions={permissions}>
                                    <NavItem>
                                        <Link to="/lists/list-tracking" className='text-nowrap'>
                                            <div>
                                                <img src={img5} alt="list-tracking" width="33" />
                                            </div>
                                            <Trans>List Tracking</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>
                                } 

                                {isAccounting &&<PermissionWrapper permissions={permissions} access={settingPerms} func={any}>
                                    <NavItem>
                                        <Link to="/settings" className='text-nowrap'>
                                            <div>
                                                <img src={img6} alt="settings" width="30" />
                                            </div>
                                            <Trans>Settings</Trans></Link>
                                    </NavItem>
                                </PermissionWrapper>}

                                {isAdmin &&
                                  <NavItem>
                                    <Link to="/global_settings" className='text-nowrap'>
                                        <div>
                                            <img src={img6} alt="settings" width="30" />
                                        </div>
                                        <Trans>SuperUser Settings</Trans></Link>
                                  </NavItem>
                                }
                            </Nav>
                            <hr style={{ display: 'block', marginTop: "10px" }} />
                        </div>
                    </Container>


                </Col>
            </Row>
        </div>
    );
}

export default SelectionComponents;
